import { render, staticRenderFns } from "./businessOwner.vue?vue&type=template&id=e73f85a6&scoped=true"
import script from "./businessOwner.vue?vue&type=script&lang=js"
export * from "./businessOwner.vue?vue&type=script&lang=js"
import style0 from "./businessOwner.vue?vue&type=style&index=0&id=e73f85a6&prod&scoped=true&lang=css"
import style1 from "./businessOwner.vue?vue&type=style&index=1&id=e73f85a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73f85a6",
  null
  
)

export default component.exports